<template>
  <div>
    <span v-if="score">
      {{score}} 점
      <mdb-btn class="p-1" icon="search" @click="$emit('view-result')"> 결과보기</mdb-btn>
    </span>
    <span v-else-if="!testDate"><!--평가 없음--></span>
    <span v-else-if="$isTestDate(testDate)">
      <mdb-btn class="p-1" icon="edit" color="primary" @click="$emit('test')"> 응시하기</mdb-btn>
    </span>
    <span v-else>
      {{$strDate(testDate)}}
    </span>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'TestStatus',
  components: {},
  props: ['score', 'testDate'],
  data: () => ({
    TAG: 'TestStatus :'
  }),
  computed: {
  }
}
</script>
